export const messageResponse = {
	successChangePassword: "Thay đổi mật khẩu thành công ",
	successUpdate: "Thay đổi thông tin thành công",
	successDelete: "Xóa tài khoản thành thành công"
}

